import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './MobileNav.css';

const MobileNav = () => {
  const location = useLocation();
  const [activePage, setActivePage] = useState('home');

  const navItems = [
    { id: 'home', label: 'Home', path: '/', icon: '🏠' },
    { id: 'services', label: 'Services', path: '/service', icon: '⚙️' },
    { id: 'projects', label: 'Projects', path: '/project', icon: '📁' },
    { id: 'about', label: 'About', path: '/about', icon: 'ℹ️' },
    { id: 'contact', label: 'Contact', path: '/contact', icon: '📧' }
  ];

  // Set active page based on location
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') setActivePage('home');
    else if (path === '/service') setActivePage('services');
    else if (path === '/project') setActivePage('projects');
    else if (path === '/about') setActivePage('about');
    else if (path === '/contact') setActivePage('contact');
  }, [location]);

  return (
    <nav className="mobile-bottom-nav">
      {navItems.map(item => (
        <Link
          key={item.id}
          to={item.path}
          className={`mobile-nav-item ${activePage === item.id ? 'active' : ''}`}
          aria-label={item.label}
        >
          <span className="mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default MobileNav;